import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-manual-payment-modal',
  templateUrl: './manual-payment-modal.component.html',
  styleUrls: ['./manual-payment-modal.component.scss'],
})
export class ManualPaymentModalComponent implements OnInit, OnDestroy {
  @Output() _updatePayment = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<ManualPaymentModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {}

  _continue() {
    this.dialogRef.close(this.data);
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {}
}
